// Pure helpers for the "Close organisation" card (tested in test/closeOrgModel.test.ts).

/** Role claim of the dashboard JWT (the API enforces it; the card only hides itself). */
export function roleFromToken(token: string | null | undefined): string | null {
    const part = token?.split('.')[1]
    if (!part) {
        return null
    }
    try {
        const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'))
        const claims = JSON.parse(json) as { role?: unknown; isSuperAdmin?: unknown }
        if (claims.isSuperAdmin === true) {
            return 'owner'
        }
        return typeof claims.role === 'string' ? claims.role : null
    } catch {
        return null
    }
}

/** Typed confirmation: the organisation's slug, exactly (case-insensitive, trimmed). */
export function confirmationMatches(typed: string, slug: string): boolean {
    return slug.length > 0 && typed.trim().toLowerCase() === slug.toLowerCase()
}

/** Whole days left until the purge starts (never negative). */
export function daysUntil(iso: string, now = Date.now()): number {
    return Math.max(0, Math.ceil((Date.parse(iso) - now) / 86_400_000))
}
